<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mt-0">{{titles.organisationListExpression}}</h4>
                        <b-row class="mb-2">
                            <TablePerPageSelect :perPage="perPage" @method="setPerPage"/>
                            <TableAddButton :nameButton="titles.organisationAddExpression"
                                            :params="{ table: 'organisation'}"
                                            :showAddButton="showAddButton"
                                            pathName="addOrganisation"
                                            v-if="!$route.path.includes('client')"/>
                        </b-row>
                        <b-table
                                :busy="isBusy"
                                :current-page="currentPage"
                                :emptyText="titles.emptyData"
                                :fields="fields"
                                :items="items"
                                :per-page="0"
                                :responsive="true"
                                @sort-changed="sortingChanged"
                                class="organisations-table"
                                id="org-table"
                                no-local-sorting
                                show-empty
                        >
                            <template #empty="scope">
                                <Loading v-if="inProgess"/>
                                <p class="emptyData" v-if="!inProgess">{{ scope.emptyText }}</p>
                            </template>
                            <template v-slot:head(Actions)>
                                <TableIconFilter :showFilter="showFilter"
                                                 @changeValShowFilter="changeValShowFilter"/>
                            </template>
                            <template class="search-input" v-if="showFilter" v-slot:top-row>
                                <TableFilterInput :type="'text'"
                                                  @method="debouncedFetchModules"
                                                  name="organisation.name"
                                                  placeholder="Nom de l'organisation"/>
                                <TableFilterInput :type="'text'"
                                                  @method="debouncedFetchModules"
                                                  name="organisation.client.firstName"
                                                  placeholder="Nom de client"
                                                  v-if="showClientName"/>
                                <TableFilterSelect :options="domains"
                                                   :text="'name'"
                                                   :val="'name'"
                                                   @method="debouncedFetchModules"
                                                   name="packCountryDomain.domain.name"
                                                   placeholder="Secteur d'activité"/>


                                <TableFilterInput :type="'number'"
                                                  @method="debouncedFetchModules" name="packCountryDomain.numberOfUsers"
                                                  placeholder="0"/>


                                <TableFilterSelect :options="packs"
                                                   :text="'label'"
                                                   :val="'label'"
                                                   @method="debouncedFetchModules"
                                                   name="packCountryDomain.typePack.label"
                                                   placeholder="Pack"/>
                                <span/>

                                <TableFilterSelect :options="paiementMode"
                                                   :text="'text'"
                                                   :val="'value'"
                                                   @method="debouncedFetchModules"
                                                   name="isPayed"
                                                   placeholder="Etat"/>

                                <TableFilterDatePicker @method="debouncedFetchModules"
                                                       name="startDate"
                                                       placeholder="DD/MM/YYYY"/>

                                <TableFilterDatePicker @method="debouncedFetchModules"
                                                       name="endDate"
                                                       placeholder="DD/MM/YYYY"/>

                            </template>
                            <template v-slot:cell(packCountryDomain)="data">
                                <span v-if="data.item.packCountryDomain.country.stripe === true">
                                    {{data.item.nbreUser}}
                                </span>
                                <span v-else-if="data.item.packCountryDomain.country.stripe === false">
                                    {{data.item.packCountryDomain.numberOfUsers}}
                                </span>
                            </template>
                            <template v-slot:cell(startDate)="data">
                                <span v-if="data.value">{{ tableList.formatedDate(tableList.filterMoment(data.value)) }}</span>
                                <span v-if="!data.value">--------------</span>
                            </template>
                            <template v-slot:cell(organisation.address)="data">
              <span :title="data.value" v-b-tooltip.hover v-if="data.value">{{
                data.value
              }}</span>
                                <span v-if="!data.value">--------------</span>
                            </template>
                            <template v-slot:cell(endDate)="data">
                                <span v-if="!data.value">--------------</span>
                                <span
                                        style="color: #ef4d56 !important;"
                                        v-else-if="tableList.dateDiff(data.value) <= 0"
                                >{{ tableList.formatedDate(tableList.filterMoment(data.value)) }}</span
                                >
                                <span v-else>{{ tableList.formatedDate(tableList.filterMoment(data.value)) }}</span>
                            </template>
                            <template v-slot:cell(packCountryDomain.typePack.label)="data">
                <span :class="'badge font-12 w-100 pack-order-'+data.item.packCountryDomain.typePack.packOrder">
                  {{data.item.packCountryDomain.typePack.label}}
                </span>
                            </template>
                            <template v-slot:cell(montant)="data">
                <span :class="'badge font-12 w-100 pack-order-'+data.item.packCountryDomain.typePack.packOrder">
                {{data.item.payedPrice}} {{data.item.currency}}
                </span>
                            </template>
                            <template v-slot:cell(isPayed)="data">
                                <span v-if="data.value === true">{{titles.paid}}</span>
                                <span v-else-if="data.value === false">{{titles.unpaid}}</span>
                                <span v-else>----------</span>
                            </template>

                            <template v-slot:cell(organisation.linkToStark)="data">
                                <span v-if="data.item.organisation.linkToStark === null">{{titles.starkInstanceInProgress}}</span>
                                <a v-else target="_blank" :href="data.item.organisation.linkToStark"> {{data.item.organisation.linkToStark}}</a>
                            </template>
                            <template v-slot:cell(Actions)="data">
                                <TableEditInfoElement :params="{ organisationId: data.item.organisation.id,
                           subscriptionItem: data.item,
                           organisationItem: data.item.organisation,
                           packCountryDomainItem: data.item.packCountryDomain,
                           clientItem: $route.params.clientItem ? $route.params.clientItem: null,
                           isEditable: isEditable,
                           goToTab: 'OrganisationInfo',
                           table: 'organisation'}"
                                                      name='UpdateOrganisation'/>
                                <TableDeleteElement :id="data.item.organisation.id" @method="deleteOrganisation"
                                                    v-if="role == roles.admin"/>
                                <a
                                        @click="goTo(data.item.id,data.item)"
                                        title="Payer"
                                        type="button"
                                        v-b-tooltip.hover.top
                                        v-if="
                  (data.item.packCountryDomain.isFree == false ||
                    tableList.dateDiff(data.item.endDate) <= 0 || data.item.payedPrice>0) &&
                    role == roles.client && data.item.isPayed == false
                "
                                ><i class="fas fa-cart-plus table-action-2"></i
                                ></a>
                                <a
                                        :disabled="underProcess"
                                        :title="titles.acceptPayment"
                                        @click="validatePayement(data.item.id, data.item,true)"
                                        type="button"
                                        v-b-tooltip.hover.top
                                        v-if="(role != roles.client && data.item.isPayed == false &&
                      data.item.packCountryDomain.country.stripe == false && data.item.organisation.client.enabled
                      && data.item.payedPrice>0)"
                                ><i class="fas fa-check table-action-2"></i
                                ></a>
                                <a
                                        :disabled="underProcess"
                                        :title="titles.declinePayment"
                                        @click="validatePayement(data.item.id, data.item,false)"
                                        type="button"
                                        v-b-tooltip.hover.top
                                        v-if="(role != roles.client && data.item.isPayed == true &&
                      data.item.packCountryDomain.country.stripe == false && data.item.organisation.client.enabled
                      && data.item.payedPrice>0)"
                                ><i class="fas fa-times table-action-2"></i
                                ></a>
                            </template>
                        </b-table>
                        <TablePagination :currentPage="currentPage" :perPage="perPage" :rows="rows"
                                         @method="setCurrentPage"/>

                    </div>
                    <!--end card-body-->
                </div>
                <!--end card-->
            </div>
            <!--end col-->
        </div>
        <modal-success
                :title="titles.successPayment"
                @messageFromModal="closeModal"
                id="validate-payement"
        />
        <modal-success
                :title="titles.cancelPayment"
                @messageFromModal="closeModal"
                id="reset-payement"
        />
    </div>
    <!--end row-->
</template>

<script>
    import {roles} from '../../utils/general/roles';
    import {deleteOrganisation} from '../shared/services/organisations.service';
    import {filterMixin} from '@/utils/filterMixin';
    import {debounce} from 'vue-debounce';
    import {titles} from '../../utils/general/titles.js';
    import {tableList} from '../../utils/general/tableList';
    import TablePerPageSelect from '@/components/common/TablePerPageSelect';
    import TablePagination from '@/components/common/TablePagination';
    import TableAddButton from '@/components/common/TableAddButton';
    import TableFilterInput from '@/components/common/TableFilterInput';
    import TableIconFilter from '@/components/common/TableIconFilter';
    import TableFilterSelect from '@/components/common/TableFilterSelect';
    import TableFilterDatePicker from '@/components/common/TableFilterDatePicker';
    import TableDeleteElement from '@/components/common/TableDeleteElement';
    import TableEditInfoElement from '@/components/common/TableEditInfoElement';
    import router from '../../router';
    import ModalSuccess from '../common/modal-success';
    import {getAllTypePacks} from '../shared/services/typePack.service';
    import {getAllDomains} from '../shared/services/domain.service';
    import {sendFacture} from '../shared/services/payment.service';
    import {
        getSubscriptionsList,
        updateSubscription
    } from '../shared/services/subscriptions.service';
    import Loading from '../common/Loading';

    export default {
        name: 'organisations-table',
        components: {
            Loading,
            TablePerPageSelect,
            TableAddButton,
            TablePagination,
            TableFilterInput,
            TableIconFilter,
            TableFilterSelect,
            TableFilterDatePicker,
            TableDeleteElement,
            TableEditInfoElement,
            ModalSuccess
        },
        props: {
            okPressed: {
                type: Boolean,
                required: false
            },
            showAddButton: {
                type: Boolean,
                default: true
            },
            tabName: String
        },
        data() {
            return {
                titles,
                roles,
                tableList,
                filterList: [],
                role: '',
                isBusy: true,
                domains: [],
                value: '',
                end_value: '',
                packs: [],
                sort: tableList.sort,
                filterQuery: tableList.filterQuery,
                direction: tableList.direction,
                perPage: tableList.perPage,
                currentPage: tableList.currentPage,
                showFilter: tableList.showFilter,
                rows: null,
                organisationId: null,
                fields: [
                    tableList.fieldTable('organisation.name', titles.organisationName, true),
                    tableList.fieldTable('organisation.client.firstName', 'Client'),
                    tableList.fieldTable('packCountryDomain.domain.name', titles.activityArea),
                    tableList.fieldTable('packCountryDomain', titles.numberOfUsers),
                    tableList.fieldTable('packCountryDomain.typePack.label', titles.organisationPack),
                    tableList.fieldTable('montant', titles.organisationMontant),
                    tableList.fieldTable('isPayed', titles.organisationPaymentState),
                    tableList.fieldTable('startDate', titles.organisationStartDate),
                    tableList.fieldTable('endDate', titles.organisationEndDate),
                    tableList.fieldTable('organisation.linkToStark', titles.organisationLinkToStark),
                    tableList.fieldTable('Actions', '', false)
                ],
                items: [],
                isEditable: true,
                inProgess: true,
                underProcess: false,
                paiementMode: [
                    {
                        text: 'payé',
                        value: 1
                    },
                    {
                        text: 'non payé',
                        value: 0
                    }
                ],
                showClientName: true
            };
        },
        mixins: [filterMixin],
        created() {
            this.$cookies.remove('subscriptionItem');
            this.$cookies.remove('organisationDetailItem');
            this.$cookies.remove('packCountryDomainDetailItem');
            this.$cookies.remove('organisationItemIsEditable');
            this.$cookies.remove('price');
            this.$cookies.remove('priceToPay');
            this.$cookies.remove('tva');
            this.$cookies.remove('voucher');
            this.$cookies.remove('currency');
            this.$cookies.remove('paymentItemId');
            this.orderQueryGenerator('id', true);
            if (this.tabName == 'Organisations') {
                this.fields.splice(this.fields.indexOf(this.fields.find(item => item.label == 'Client')), 1);
                this.showClientName = false;
            }
        },
        methods: {
            goTo(id, item) {
                if (item.packCountryDomain.country.stripe == true) {
                    router.push({name: 'payment', params: {id, item}});
                } else {
                    item.price = parseFloat(item.price).toFixed(item.decimalDigits);
                    item.payedPrice = parseFloat(item.payedPrice).toFixed(item.decimalDigits);
                    sendFacture(item).then(response => {
                        if (response.data == 'Email submitted') {
                            this.$bvModal.show('cannot-pay-subscription');
                        }
                    });
                }
            },
            validatePayement(id, item, val) {
                if (this.underProcess == false) {
                    this.underProcess = true;
                    const localItem = Object.assign({}, item);
                    localItem.isPayed = val;
                    delete localItem.organisation;
                    delete localItem.packCountryDomain;
                    updateSubscription(id).then(
                        response => {
                            this.underProcess = false;
                            if (val == false) {
                                this.$bvModal.show('reset-payement');
                            } else {
                                this.$bvModal.show('validate-payement');
                            }
                            return response;
                        }
                    );
                }
            },
            deleteOrganisation(id) {
                if (new Date(this.items.find(subscription => subscription.organisation.id == id).endDate) > new Date()) {
                    this.$bvModal.show('cannot-delete-organisation');
                } else {
                    this.$bvModal.show('delete-organisation');
                    this.organisationId = id;
                }
            },
            debouncedFetchModules: debounce(function (column, val, type, direction) {
                this.fetchOrganisations(column, val, type, direction);
            }, 300),
            changeValShowFilter(val) {
                this.showFilter = val;
            },
            setCurrentPage(val) {
                this.currentPage = val;
            },
            setPerPage(val) {
                this.perPage = val;
            },
            openDetailsModal(organisation, packs) {
                this.$emit('Organisation', organisation);
                this.$emit('Domains', this.domains);
                this.$emit('Packs', packs);
                this.$bvModal.show('organisation-detail');
            },

            sortingChanged(ctx) {
                this.orderQueryGenerator(ctx.sortBy, ctx.sortDesc);
                this.fetchOrganisations();
            },
            async fetchOrganisations(column, val, type, direction) {
                this.inProgess = true;
                this.items = [];
                if (column) {
                    this.filterList = this.filterQueryGenerator(
                        this.filterList,
                        column,
                        val,
                        type,
                        direction
                    );
                }
                getSubscriptionsList(
                    this.perPage,
                    this.currentPage,
                    this.sort,
                    this.filterQuery
                ).then(response => {
                    this.isBusy = false;
                    this.items = response.data['hydra:member'];
                    this.rows = response.data['hydra:totalItems'];
                    this.inProgess = false;
                });
            },
            closeModal() {
                this.fetchOrganisations();
            }
        },
        mounted() {
            this.role = this.$store.getters.role;
            if (this.$route.params.id) {
                this.debouncedFetchModules('organisation.client.id', this.$route.params.id);
            } else {
                this.fetchOrganisations();
            }
            this.filterList = this.filterQueryGenerator(
                this.filterList,
                'isActive',
                '1',
                null
            );
            getAllDomains(
                null, null, null, this.filterQuery
            ).then(response => {
                this.domains = response.data['hydra:member'];
            });
            getAllTypePacks(
                this.filterQuery
            ).then(response => {
                this.packs = response.data['hydra:member'];
            });
        },
        watch: {
            okPressed() {
                if (this.okPressed) {
                    deleteOrganisation(this.organisationId).then(
                        response => {
                            if (response.data == 'Cannot delete') {
                                this.$bvModal.show('cannot-delete-organisation');
                            } else {
                                this.$emit('deleted', false);
                                this.$bvModal.show('success-delete-organisation');
                                this.fetchOrganisations();
                            }
                            return response;
                        }
                    );
                }
            },
            currentPage: {
                handler() {
                    this.fetchOrganisations();
                }
            },
            perPage: {
                handler() {
                    this.fetchOrganisations();
                }
            }
        }
    };
</script>

<style type="scss">
    @import "../../assets/style/css/b-table.css";
    @import '../../assets/style/css/organisations/table.css';
</style>
